import styled, { css } from 'styled-components';
import { neutralWhite, blue400, navyDark, navySlate } from '../themes/colors';

export const ListWrapper = styled.div`
	font-family: "Red Hat Display", sans-serif;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

const BaseRow = styled.div`
	display: flex;
	align-items: center;
	background: ${neutralWhite};
	border-radius: 4px;
	border: 1px solid transparent;
`;

export const TitleRow = styled(BaseRow)``;

export const ListItem = styled(BaseRow)<{ $isDragging?: boolean }>`
	border-color: ${props => props.$isDragging ? blue400 : 'transparent'};
`;

export const DragHandle = styled.div<{ $isDragging?: boolean }>`
	color: ${props => props.$isDragging ? blue400 : navyDark};
	margin: 0 8px 0 6px;
	cursor: grab;

	&:active {
		cursor: grabbing;
	}
`;

export const IconWrapper = styled.div`
	margin: 0 8px 0 0;
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	gap: 4px;
	padding: 7px 0;
	overflow: hidden;
	min-width: 0;
`;

const truncateText = css`
	font-size: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
	margin: 0;
`;

export const MainText = styled.p`
	${truncateText}
	color: ${navyDark};
	font-weight: 400;
`;

export const TitleText = styled.h3`
	${truncateText}
	color: ${navyDark};
	font-weight: 500;
`;

export const Feature = styled.p`
	font-size: 14px;
	white-space: nowrap;
	margin: 0;
	color: ${navySlate};
	font-weight: 400;
`;
